import { isAction, Middleware } from "@reduxjs/toolkit";
import { log } from "./logger.ts";

export const diffLogger: Middleware = (store) => (next) => (action) => {
  const prevState = store.getState() as Record<string, unknown>;
  const result = next(action);
  const nextState = store.getState() as Record<string, unknown>;

  if (!isAction(action)) {
    return next(action);
  }

  Object.keys(nextState).forEach((key) => {
    if (prevState[key] !== nextState[key]) {
      log(`🪵 ${action.type} changed ${key}`);
      log("prev:", prevState[key]);
      log("next:", nextState[key]);
    }
  });

  return result;
};
